import Home from "./ui/pages/home/Home";
import News from "./ui/pages/news/News";
import CityHall from "./ui/pages/cityHall/CityHall";
import Contractor from "./ui/pages/contractor/Contractor";
import Communication from "./ui/pages/communication/Communication";
import AndroidDownload from "./ui/pages/androidDownload/AndroidDownload";

const config = [
    {
        name: "home", path: "/", exact: true, title: "Geolux - A solução para gerenciar a iluminação pública de sua cidade!", component: Home,
        metaTags: [
            { property: "og:title", content: "Geolux - A solução para gerenciar a iluminação pública de sua cidade!" },
            { property: "og:description", content: "Geolux é um sistema que facilita gerenciar a iluminação pública da sua cidade, provendo gestão de recursos, inúmeros relatórios e um sistema georreferenciado." },
            { name: "description", content: "Geolux é um sistema que facilita gerenciar a iluminação pública da sua cidade, provendo gestão de recursos, inúmeros relatórios e um sistema georreferenciado." },
            { property: "og:type", content: "website" },
        ]
    },
    {
        name: "news", path: "/noticias", title: "Geolux - Notícias", component: News,
        metaTags: [
            { property: "og:title", content: "Geolux - Notícias" },
            { property: "og:description", content: "Veja as principais notícias de cidades que utilizam o Geolux." },
            { name: "description", content: "Veja as principais notícias de cidades que utilizam o Geolux." },
            { property: "og:type", content: "website" },
        ]
    },
    {
        name: "cityHall", path: "/prefeituras", title: "Geolux - Prefeituras", component: CityHall,
        metaTags: [
            { property: "og:title", content: "Geolux - Prefeituras" },
            { property: "og:description", content: "Trabalha com iluminação pública? Conheça as vantagens de utilizar o Geolux para gerenciar seus processos!" },
            { name: "description", content: "Trabalha com iluminação pública? Conheça as vantagens de utilizar o Geolux para gerenciar seus processos!" },
        ]
    },
    {
        name: "contractor", path: "/empreiteiras", title: "Geolux - Empreiteiras", component: Contractor,
        metaTags: [
            { property: "og:title", content: "Geolux - Empreiteiras" },
            { property: "og:description", content: "Geolux para empreiteiras: gerencie seu estoque, suas equipes e suas demandas de maneira muito fácil!" },
            { name: "description", content: "Geolux para empreiteiras: gerencie seu estoque, suas equipes e suas demandas de maneira muito fácil!" },
        ]
    },
    {
        name: "communication", path: "/canais", title: "Geolux - Canais de Comunicação", component: Communication,
        metaTags: [
            { property: "og:title", content: "Geolux - Canais de Comunicação" },
            { property: "og:description", content: "Os canais de comunicação Geolux permitem que os munícipes consigam comunicar e acompanhar problemas ocorridos na iluminação pública do município." },
            { name: "description", content: "Os canais de comunicação Geolux permitem que os munícipes consigam comunicar e acompanhar problemas ocorridos na iluminação pública do município." },
        ]
    },
    {
        name: "androidDownload", path: "/mobile", title: "Geolux - Aplicativo Android", component: AndroidDownload,
        metaTags: [
            { property: "og:title", content: "Geolux - Aplicativo Android" },
            { property: "og:description", content: "O aplicativo Geolux para Android permite que você gerencie suas demandas de iluminação pública de forma muito fácil e rápida." },
            { name: "description", content: "O aplicativo Geolux para Android permite que você gerencie suas demandas de iluminação pública de forma muito fácil e rápida."},
        ]
    },
];

export default config;
